export default {"src":"/_next/static/media/cdek-white.11de5448.svg","height":14,"width":51,"blurWidth":0,"blurHeight":0};